/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminPaymentListVo } from './AdminPaymentListVo';
import {
    AdminPaymentListVoFromJSON,
    AdminPaymentListVoFromJSONTyped,
    AdminPaymentListVoToJSON,
    AdminPaymentListVoToJSONTyped,
} from './AdminPaymentListVo';

/**
 * 
 * @export
 * @interface ResponseAdminPaymentListVo
 */
export interface ResponseAdminPaymentListVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminPaymentListVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminPaymentListVo
     */
    message?: string;
    /**
     * 
     * @type {AdminPaymentListVo}
     * @memberof ResponseAdminPaymentListVo
     */
    data?: AdminPaymentListVo;
}

/**
 * Check if a given object implements the ResponseAdminPaymentListVo interface.
 */
export function instanceOfResponseAdminPaymentListVo(value: object): value is ResponseAdminPaymentListVo {
    return true;
}

export function ResponseAdminPaymentListVoFromJSON(json: any): ResponseAdminPaymentListVo {
    return ResponseAdminPaymentListVoFromJSONTyped(json, false);
}

export function ResponseAdminPaymentListVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminPaymentListVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminPaymentListVoFromJSON(json['data']),
    };
}

export function ResponseAdminPaymentListVoToJSON(json: any): ResponseAdminPaymentListVo {
    return ResponseAdminPaymentListVoToJSONTyped(json, false);
}

export function ResponseAdminPaymentListVoToJSONTyped(value?: ResponseAdminPaymentListVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminPaymentListVoToJSON(value['data']),
    };
}

